/**
 * Utility functions for generating booking URLs
 */

/**
 * Generate a direct booking URL using the current host
 * @param bookingId - The booking ID
 * @returns The complete booking URL to dedicated page
 */
export function generateBookingUrl(bookingId: string): string {
  const currentHost = window.location.host;
  const protocol = window.location.protocol;
  return `${protocol}//${currentHost}/bookings/${bookingId}`;
}

/**
 * Open a booking in a new tab
 * @param bookingId - The booking ID
 */
export function openBookingInNewTab(bookingId: string): void {
  const url = generateBookingUrl(bookingId);
  window.open(url, '_blank');
}

/**
 * Copy booking URL to clipboard
 * @param bookingId - The booking ID
 * @returns Promise that resolves when copied
 */
export async function copyBookingUrl(bookingId: string): Promise<void> {
  const url = generateBookingUrl(bookingId);
  await navigator.clipboard.writeText(url);
}
